import React, { memo, useEffect, useRef, useState } from "react";
import HeaderPage from "../../components/HeaderPage/Index";
import Loading from "../../components/loading/loading";
import {
  getData,
  storeData,
  clearData,
  checkEditPage,
  getAllCountry,
} from "../../utils/GlobalHelper";
import { isMobile } from "react-device-detect";
import GlobalApi from "../../utils/GlobalApi";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import Configs from "../../constants/Configs";
import {
  Autocomplete,
  FormControl,
  Grid,
  TextField,
  Typography,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  FormLabel,
  RadioGroup,
  Radio,
  Button,
  Box,
} from "@mui/material";
import clsx from "clsx";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { englishStringFormat, taxNumberValidate } from "../../utils/formatter";
import {
  CRSDeclareLocationKey,
  CRSEditData,
  DeleteFlag,
  EditFlag,
} from "../../utils/GlobalKey";
import styles from "./Crs.module.css";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import { isEmpty, isEqual } from "lodash";
import { fomatterEN } from "../../utils/formatter";

const DataKey = CRSDeclareLocationKey;
const EditKey = CRSEditData;

const CRSForm = (props) => {
  const translations = getData("Translations");
  const [isLoading, setIsLoading] = useState(false);
  const [countrysList, setCountryList] = useState([]);
  const [optionsCountry, setOptionsCountry] = useState([]);
  const [crsData, setCrsData] = useState([]);
  const [crsEditData, setCrsEditData] = useState();
  const [lang, setLang] = useState(getData("lang"));

  const [idcData, setIdcData] = useState();

  const [information, setInformation] = useState({
    countryId: "",
    country: "",
    taxNumber: "",
    checkNotax: false,
    notaxId: 0,
    notaxId2Text: "",
  });
  const [isModalDelete, setIsModalDelete] = useState(false);
  const [isModalBack, setIsModalBack] = useState(false);
  const [editUrl, setEditUrl] = useState(false);

  const checkEditUrl = () => {
    checkEditPage().then((res) => setEditUrl(res));
  };

  const getCountrys = async (excludeData) => {
    setIsLoading(true);
    try {
      await getAllCountry()
        .then(async (res) => {
          setIsLoading(false);
          //ไม่แสดง สหรัฐอเมริกา
          const cleanData = res.filter(
            (country) => country.ThName != "สหรัฐอเมริกา",
          );

          let list = cleanData.map((country) => {
            return {
              value: country.Id,
              label: country.ThName,
            };
          });

          // console.log(list);
          const newSourceIncome = list.filter(
            (item) => !excludeData.includes(Number(item.value)),
          );
          // console.log("New data : ", newSourceIncome);
          setCountryList(newSourceIncome);
          setOptionsCountry(newSourceIncome);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };

  const handleNextButton = () => {
    let data = [];
    if (crsData.length > 0) {
      data = crsData.filter((x) => x.countryId !== information.countryId);
    }

    //ลบ เหตุผล ออกก่อน Save
    let clearInformation = information;

    if (information.notaxId != 2) {
      clearInformation.notaxId2Text = "";
      setInformation(clearInformation);
    }

    data.push(information);
    setCrsData(data);

    storeData(DataKey, data);

    if (editUrl) {
      props.history.goBack();
      // props.history.push("/declare_location/edit");
    } else {
      props.history.goBack();
      // props.history.push("/declare_location");
    }
  };

  const handleEditButton = () => {
    let data = [];
    if (crsData.length > 0 && crsEditData) {
      data = crsData.filter((x) => x.countryId !== crsEditData.countryId);
    }

    //ลบ เหตุผล ออกก่อน Save
    let clearInformation = information;

    if (information.notaxId != 2) {
      clearInformation.notaxId2Text = "";
      setInformation(clearInformation);
    }

    // data.push(information);
    data.push(clearInformation);
    setCrsData(data);

    storeData(DataKey, data);
    clearData(EditKey);
    storeData(EditFlag, "true");

    if (editUrl) {
      props.history.goBack();
      // props.history.push("/declare_location/edit");
    } else {
      props.history.goBack();
      // props.history.push("/declare_location");
    }
  };

  const handleDelete = () => {
    let data = [];
    const editData = getData(EditKey);
    if (crsData.length > 0) {
      data = crsData.filter((x) => x.countryId !== editData.countryId);
    }
    // console.log("Data : ", data);
    setCrsData(data);
    storeData(DataKey, data);
    storeData(DeleteFlag, "true");

    clearData(EditKey);

    if (editUrl) {
      props.history.goBack();
      // props.history.push("/declare_location/edit");
    } else {
      props.history.goBack();
      // props.history.push("/declare_location");
    }
  };

  // ครั้งแรก โหลด ประเทศ ทั้งหมด
  useEffect(async () => {
    const storeCrsData = getData(DataKey);
    // console.log("storeCrsData : ", storeCrsData);
    if (storeCrsData) {
      setCrsData(storeCrsData);
    }

    const editData = getData(EditKey);
    let excludeData = [];
    if (editData) {
      // console.log("editData : ", editData);
      setCrsEditData(editData);
      setInformation(editData);
      excludeData = storeCrsData
        .filter((x) => x.countryId !== editData.countryId)
        .map((item) => Number(item.countryId));
    } else if (!editData && storeCrsData) {
      excludeData = storeCrsData.map((item) => Number(item.countryId));
    }

    await getCountrys(excludeData);
    const idcStorage = getData("idc");
    setIdcData(idcStorage);

    //check edit page
    checkEditUrl();
  }, []);

  // console.log("Crs Data ", crsData);

  const handleInput = (key, value) => {
    switch (key) {
      case "country":
        if (value !== null) {
          if (value.label === "ไทย") {
            setInformation({
              ...information,
              countryId: value.value,
              country: value.label,
              notaxId: 0,
              notaxId2Text: "",
              checkNotax: false,
              taxNumber: idcData.idCard,
            });
          } else {
            setInformation({
              ...information,
              countryId: value.value,
              country: value.label,
              taxNumber: "",
            });
          }
        } else {
          setInformation({
            ...information,
            countryId: "",
            country: "",
            notaxId: 0,
            notaxId2Text: "",
            checkNotax: false,
            taxNumber: "",
          });
        }

        break;
      case "notax":
        setInformation({ ...information, notaxId: Number(value) });
        break;
      case "taxNumber":
        if (taxNumberValidate(value)) {
          setInformation({ ...information, taxNumber: value });
        }

        break;
      case "checkbox":
        if (value === true) {
          setInformation({ ...information, taxNumber: "", checkNotax: value });
        } else {
          setInformation({
            ...information,
            notaxId: 0,
            notaxId2Text: "",
            checkNotax: value,
            taxNumber: "",
          });
        }

        break;
      case "notaxId2Text":
        setInformation({ ...information, notaxId2Text: fomatterEN(value) });
        // if (englishStringFormat(value)) {
        //   setInformation({ ...information, notaxId2Text: value });
        // }

        break;
    }
  };
  const handleEnableButton = () => {
    const previousData = getData(CRSEditData);

    // handle enable button when edit
    if (previousData) {
      if (isEqual(previousData, information)) {
        return false;
      }
    }

    let result = false;
    if (information.country !== "" && information.taxNumber !== "") {
      result = true;
    } else if (
      information.country !== "" &&
      information.checkNotax &&
      information.notaxId !== 0
    ) {
      if (information.notaxId === 2 && information.notaxId2Text !== "") {
        result = true;
      } else if (information.notaxId !== 2) {
        result = true;
      }
    }
    // console.log("Enable ", result);
    return result;
  };

  const clickBack = () => {
    const previousData = getData(CRSEditData);

    //ถ้าเป็น case Insert ให้ back กลับได้
    if (!previousData) {
      handleBackButton(true);
    } else if (!isEqual(previousData, information)) {
      setIsModalBack(true);
    } else {
      handleBackButton(true);
    }
  };

  const handleBackButton = (onClickEdit) => {
    if (onClickEdit) {
      if (editUrl) {
        props.history.goBack();
        // props.history.goBack("/declare_location/edit");
      } else {
        // props.history.push("/declare_location");
        props.history.goBack();
      }
    }
  };

  const handleModalDeleteButton = (onClickDelete) => {
    if (onClickDelete) {
      handleDelete();
    }
  };

  const handleOptionsCountry = (value) => {
    if (isEmpty(value)) {
      setOptionsCountry(countrysList);
      return;
    }

    let findMatchOptions = countrysList.filter((country) =>
      country.label.toString().startsWith(value),
    );
    setOptionsCountry(findMatchOptions);
  };

  return (
    <>
      <HeaderPage
        title="เปิดบัญชีออนไลน์"
        onChangeLang={(e) => setLang(e)}
        clickBack={(e) => (e ? clickBack() : "")}
      />
      <Loading status={isLoading} />
      {isModalDelete && (
        <DialogCustoms
          open={isModalDelete}
          isModel={setIsModalDelete}
          title={"ลบข้อมูล"}
          massage={"ท่านยืนยันการลบข้อมูลส่วนนี้หรือไม่"}
          idBtnPrimary="btn-modal-delete"
          idBtnSecondary="btn-modal-retry"
          btnPrimary={"ยืนยัน"}
          btnSecondary={"อยู่หน้านี้ต่อ"}
          switchType={(e) => handleModalDeleteButton(e)}
        />
      )}
      {isModalBack && (
        <DialogCustoms
          open={isModalBack}
          isModel={setIsModalBack}
          title={"ยกเลิกการแก้ไข"}
          massage={"การแก้ไขยังไม่ได้ถูกบันทึก ท่านต้องการออกจากหน้านี้หรือไม่"}
          idBtnPrimary="btn-modal-back"
          idBtnSecondary="btn-modal-retry"
          btnPrimary={"ออกจากหน้านี้"}
          btnSecondary={"อยู่หน้านี้ต่อ"}
          switchType={(e) => handleBackButton(e)}
        />
      )}
      <Grid className="background-bg">
        <Grid className="section-consent">
          <Grid className={isMobile ? "box-content-mb" : "box-content"}>
            <Grid container className="box-content-main" columns={16}>
              {!isMobile && (
                <Grid item xs={7} className="box-left">
                  <BoxLeftContent
                    translations={translations?.[lang]?.checkuserinfo}
                    // editUrl={editUrl}
                    clickBack={(e) => clickBack()}
                  />
                </Grid>
              )}
              <Grid
                item
                xs={isMobile ? 16 : 9}
                className={isMobile ? "box-right-mb" : "box-right"}
              >
                <Grid className="content">
                  <Grid className="content-main">
                    <Grid
                      className="box-right-content pb-3"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <HeaderRight />
                      <Box sx={{ flexGrow: 1 }}>
                        <ScrollBarComponent
                          content={
                            <Box>
                              <Typography
                                id="title"
                                className="text-primary"
                                style={{ textAlign: "left", fontSize: "28px" }}
                              >
                                ประเทศถิ่นที่อยู่ทางภาษี
                              </Typography>
                              <Typography
                                id="sub-title"
                                style={{
                                  textAlign: "left",
                                  fontSize: "24px",
                                  color: "#58595B",
                                  fontStyle: "normal",
                                }}
                              >
                                กรุณาระบุข้อมูลให้ครบถ้วน
                              </Typography>

                              <Grid className="input-form">
                                <FormControl variant="standard" fullWidth error>
                                  <Autocomplete
                                    id="select-country"
                                    options={optionsCountry}
                                    getOptionLabel={(option) =>
                                      option.label ? option.label : ""
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                      option.label === value.label
                                    }
                                    value={
                                      information?.countryId
                                        ? {
                                            label: information?.country,
                                            value: information?.countryId,
                                          }
                                        : null
                                    }
                                    onChange={(e, value) => {
                                      handleInput("country", value);
                                      // console.log("value ", value);
                                    }}
                                    onInputChange={(e, value, reason) => {
                                      handleOptionsCountry(value);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        id="country-tax"
                                        variant="standard"
                                        label="ประเทศถิ่นที่อยู่ทางภาษี"
                                        placeholder="ค้นหา"
                                        required
                                      />
                                    )}
                                  />
                                </FormControl>
                              </Grid>
                              {idcData && (
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <TextField
                                      className="font-20"
                                      id="taxId"
                                      label="หมายเลขประจำตัวผู้เสียภาษี"
                                      placeholder="หมายเลขประจำตัวผู้เสียภาษี"
                                      variant="standard"
                                      value={
                                        information &&
                                        information?.country === "ไทย"
                                          ? idcData?.idCard
                                          : information?.taxNumber
                                      }
                                      disabled={
                                        information?.country === "ไทย" ||
                                        information?.checkNotax
                                      }
                                      onChange={(e) =>
                                        handleInput("taxNumber", e.target.value)
                                      }
                                      inputProps={{ maxLength: 20 }}
                                    />
                                  </FormControl>
                                </Grid>
                              )}

                              {information.country !== "ไทย" && (
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                    sx={{
                                      marginLeft: "-5px",
                                    }}
                                  >
                                    <FormControlLabel
                                      id="text-checkbox"
                                      classes={{
                                        label: clsx("text-primary", "font-20"),
                                      }}
                                      value={false}
                                      control={
                                        <Checkbox
                                          id="checkbox-no-tax"
                                          checked={information?.checkNotax}
                                          onClick={() =>
                                            handleInput(
                                              "checkbox",
                                              !information.checkNotax,
                                            )
                                          }
                                        />
                                      }
                                      label={"ไม่มีหมายเลขประจำตัวผู้เสียภาษี"}
                                    />
                                  </FormControl>
                                </Grid>
                              )}

                              {information && information.checkNotax ? (
                                <Grid className="input-form">
                                  <FormControl>
                                    <FormLabel id="demo-radio-buttons-group-label">
                                      <Typography
                                        id="text-reason"
                                        className="font-20 text-primary"
                                      >
                                        โปรดระบุเหตุผล
                                      </Typography>
                                    </FormLabel>

                                    <RadioGroup
                                      aria-labelledby="demo-radio-buttons-group-label"
                                      name="radio-buttons-group"
                                    >
                                      <div
                                        style={{
                                          border: "1px solid #A7A9AC",
                                          borderRadius: "10px",
                                          background: "#FFF",
                                          padding: "10px",
                                          marginTop: "16px",
                                          paddingRight: "10px",
                                        }}
                                      >
                                        <FormControlLabel
                                          value="noTax1"
                                          id="text-notax-1"
                                          style={{ alignItems: "start" }}
                                          classes={{
                                            label: clsx(
                                              "text-primary",
                                              "font-20",
                                              "flex-start",
                                            ),
                                          }}
                                          className={styles.noTaxReason}
                                          control={
                                            <Radio
                                              id="notax-1"
                                              checked={
                                                information.notaxId === 1
                                              }
                                              onChange={(e) =>
                                                handleInput("notax", 1)
                                              }
                                              checkedIcon={<CheckCircleIcon />}
                                              disableRipple
                                            />
                                          }
                                          label={
                                            <Typography
                                              className={styles.noTaxLabel}
                                            >
                                              ประเทศที่ระบุข้างต้น
                                              ไม่ได้มีการออกเลขประจำตัวผู้เสียภาษี
                                            </Typography>
                                          }
                                        />
                                      </div>
                                      <div
                                        style={{
                                          border: "1px solid #A7A9AC",
                                          borderRadius: "10px",
                                          background: "#FFF",
                                          padding: "10px",
                                          marginTop: "16px",
                                        }}
                                      >
                                        <FormControlLabel
                                          id="text-notax-2"
                                          value="noTax2"
                                          style={{ alignItems: "start" }}
                                          classes={{
                                            label: clsx(
                                              "text-primary",
                                              "font-20",
                                            ),
                                          }}
                                          control={
                                            <Radio
                                              id="notax-2"
                                              checked={
                                                information.notaxId === 2
                                              }
                                              onChange={(e) =>
                                                handleInput("notax", 2)
                                              }
                                              checkedIcon={<CheckCircleIcon />}
                                              disableRipple
                                            />
                                          }
                                          label={
                                            <Typography
                                              className={styles.noTaxLabel}
                                            >
                                              ยังไม่ได้รับหมายเลขประจำตัวผู้เสียภาษี
                                            </Typography>
                                          }
                                        />

                                        <Typography
                                          id="text-remark-2"
                                          style={{
                                            color: "#A7A9AC",
                                            fontWeight: "normal",
                                            marginLeft: "40px",
                                          }}
                                        >
                                          (หมายเหตุ: โปรดอธิบายเหตุผลที่
                                          ท่านไม่สามารถขอหมายเลขประจำตัวผู้เสียภาษีได้)
                                        </Typography>
                                        {information &&
                                          information.notaxId === 2 && (
                                            <div
                                              style={{
                                                marginLeft: "35px",
                                                marginTop: "16px",
                                                marginRight: "10px",
                                              }}
                                            >
                                              <TextField
                                                fullWidth
                                                className="font-20"
                                                id="noTax2-reason"
                                                label="อธิบายเหตุผลเพิ่มเติม"
                                                size="small"
                                                variant="outlined"
                                                value={information.notaxId2Text}
                                                placeholder="โปรดระบุเป็นภาษาอังกฤษ"
                                                inputProps={{ maxLength: 400 }}
                                                onChange={(e) =>
                                                  handleInput(
                                                    "notaxId2Text",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          )}
                                      </div>
                                      <div
                                        style={{
                                          border: "1px solid #A7A9AC",
                                          borderRadius: "10px",
                                          background: "#FFF",
                                          padding: "10px",
                                          marginTop: "16px",
                                          paddingRight: "10px",
                                        }}
                                      >
                                        <FormControlLabel
                                          id="text-notax-3"
                                          value="noTax3"
                                          style={{ alignItems: "start" }}
                                          control={
                                            <Radio
                                              id="notax-3"
                                              checked={
                                                information.notaxId === 3
                                              }
                                              onChange={(e) =>
                                                handleInput("notax", 3)
                                              }
                                              checkedIcon={<CheckCircleIcon />}
                                              disableRipple
                                            />
                                          }
                                          classes={{
                                            label: clsx(
                                              "text-primary",
                                              "font-20",
                                            ),
                                          }}
                                          label={
                                            <Typography
                                              className={styles.noTaxLabel}
                                            >
                                              ไม่จำเป็นต้องให้หรือเปิดเผยเลขประจําตัวผู้เสียภาษี
                                            </Typography>
                                          }
                                        />

                                        <Typography
                                          id="text-remark-3"
                                          style={{
                                            color: "#A7A9AC",
                                            fontWeight: "normal",
                                            marginLeft: "40px",
                                          }}
                                        >
                                          (หมายเหตุ:
                                          เลือกเหตุผลนี้เฉพาะในกรณีที่
                                          กฎหมายภายในประเทศนั้นไม่ได้บังคับจัดเก็บเลขประจําตัวผู้เสียภาษี)
                                        </Typography>
                                      </div>
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                              ) : (
                                ""
                              )}
                              {/* ✅ เพิ่มช่องว่างท้ายสุดของ content */}
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  height: 50,
                                }}
                              />
                            </Box>
                          }
                        />
                      </Box>
                      <Box sx={{ flexShrink: 1 }}>
                        {crsEditData ? (
                          <Grid
                            container
                            direction="column"
                            justifyContent="space-evenly"
                            alignItems="stretch"
                            rowGap={1}
                          >
                            <Grid item xs="auto">
                              <Button
                                id="btn-delete"
                                className={clsx("btn-left btn-next font-32")}
                                // onClick={handleDelete}
                                onClick={() => setIsModalDelete(true)}
                              >
                                ลบทิ้ง
                              </Button>
                            </Grid>
                            <Grid item xs="auto">
                              <ButtonRight
                                id="btn-save"
                                text="บันทึกข้อมูล"
                                onNextPage={handleEditButton}
                                isDisbled={!handleEnableButton()}
                              />
                            </Grid>
                          </Grid>
                        ) : (
                          <ButtonRight
                            id="btn-save"
                            text="ยืนยัน"
                            onNextPage={handleNextButton}
                            isDisbled={!handleEnableButton()}
                          />
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(CRSForm);
